import { createUseReorder } from '~/training/sequence/templates/items/shared/useReorder';

const isCard = (i: any) =>
  i?.typename === 'Card' || i?.__typename === 'Card' || i?.type === 'CARD';

export const useReorderCards = createUseReorder({
  dataAttribute: 'data-card-id',
  className: 'cards-drag-active',
  ghostClassName: 'drag-cards-ghost',
  styleId: 'cards-drag-optimizations',
  filterFn: isCard,
  customStyles: `
    .drag-cards-ghost {
      cursor: grabbing !important;
      list-style: none !important;
    }
    .drag-cards-ghost * {
      cursor: grabbing !important;
    }
  `
});
